import { createTheme } from '@mui/material/styles'

// Minimalny motyw - zmiana kolorów primary i secondary na czarne/szare
export const customTheme = createTheme({
  palette: {
    primary: {
      main: '#000000', // Czysty czarny kolor
      light: '#333333',
      dark: '#000000',
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#000000', // Czarny zamiast fioletowego
      light: '#333333',
      dark: '#000000',
      contrastText: '#FFFFFF'
    }
  }
})